import { camelize } from 'helpers/syntaxHelper';
import { useCallback } from 'react';
import { useGetColumnType } from 'routes/Cellar/components/Preview/PreviewTable/hooks/columnType';
import { PreviewColumnT, PreviewData } from 'routes/Cellar/types';

/*
 * This callback takes the previzData and the preview columns to determine
 * the malformatted preview data. This is done within 2 step:
 *  - First, it determines the list of rows that contain at least one malformatted value
 *  - Then, it calculates the new column `types` object by counting the type occurences
 *    in each cell of the column.
 * Finally, it returns a PreviewData object representing only malformatted data.
 */
export const useMalformattedPrevizData = (
    columns: PreviewColumnT[],
    previzData: PreviewData,
    isNewTable: boolean,
    tableColumns: ResponseColumnT[],
) => {
    const getColumnType = useGetColumnType(isNewTable, tableColumns);
    return useCallback(() => {
        const malformattedRows = previzData.rows.filter((row) =>
            columns.some((column) => {
                const rowTypes: string[] = row[camelize(column.name)].types;
                const columnType = getColumnType(column);
                return (
                    // TODO StrictNullCheck : Try to remove "!"
                    !rowTypes.includes(columnType!) &&
                    !rowTypes.includes('none')
                );
            }),
        );
        const malformattedColumns = columns.map((column) => {
            const types: Partial<Record<DataTypesT, number>> = {};
            malformattedRows.forEach((row) => {
                row[camelize(column.name)].types.forEach(
                    (type) =>
                        // TODO StrictNullCheck : Try to remove "!"
                        (types[type] = types[type] ? types[type]! + 1 : 1),
                );
            });
            return { ...column, types };
        });
        return {
            ...previzData,
            columns: malformattedColumns,
            rows: malformattedRows,
            nbRows: malformattedRows.length,
        };
    }, [columns, getColumnType, previzData]);
};
